import React from 'react';
import { PriceCheckerHeader } from 'site-modules/shared/components/price-checker/price-checker-header/price-checker-header';

export function PriceCheckerThankYouHeader() {
  return (
    <div className="price-checker-thank-you-header mb-2">
      <PriceCheckerHeader />
    </div>
  );
}
